module.exports = __webpack_public_path__ + "assets/img/game_statistics.c03b3dc6.svg";